module.exports = __webpack_public_path__ + "img/whatsEatCoupon.651c961b.png";